import { INumberRangeAlertBehavior } from "./INumberRangeAlertBehavior";
import { ThresholdAlertBehavior } from "./ThresholdAlertBehavior";

export class NumberRangeAlertBehavior implements INumberRangeAlertBehavior {
  constructor(
    public upper: ThresholdAlertBehavior<number> = null,
    public lower: ThresholdAlertBehavior<number> = null,
  ) {
  }

  clone(): NumberRangeAlertBehavior {
    return new NumberRangeAlertBehavior(this.upper.clone(), this.lower.clone());
  }

  static from(source: INumberRangeAlertBehavior): NumberRangeAlertBehavior {
    return new NumberRangeAlertBehavior(ThresholdAlertBehavior.from(source.upper), ThresholdAlertBehavior.from(source.lower));
  }

  static to(source: NumberRangeAlertBehavior): INumberRangeAlertBehavior {
    return {
      upper: ThresholdAlertBehavior.to(source.upper),
      lower: ThresholdAlertBehavior.to(source.lower),
    };
  }
}
